import { forwardRef } from 'react';
import { styled } from 'goober';
export var CheckboxMenuToggle = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme, $toggleHeight = _a.$toggleHeight, _b = _a.$active, $active = _b === void 0 ? false : _b, _c = _a.$disabled, $disabled = _c === void 0 ? false : _c, _d = _a.$iconOnly, $iconOnly = _d === void 0 ? false : _d;
    return ({
        height: "".concat($toggleHeight, "px"),
        minWidth: $iconOnly ? undefined : '100px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: $iconOnly ? '0px' : '0px 0px 0px 8px',
        fontSize: '11px',
        userSelect: 'none',
        cursor: $disabled ? 'not-allowed' : 'pointer',
        color: $disabled ? theme.colors.neutral.w700 : theme.colors.ui.dark,
        backgroundColor: $disabled ? theme.colors.neutral.w200 : theme.colors.neutral.w50,
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: $disabled
            ? theme.colors.neutral.w300
            : $active
                ? theme.colors.primary.w500
                : theme.colors.neutral.w100,
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: $disabled ? theme.colors.neutral.w200 : theme.colors.neutral.w100,
            borderColor: $disabled
                ? theme.colors.neutral.w300
                : $active
                    ? theme.colors.primary.w500
                    : theme.colors.neutral.w200,
        },
    });
});
export var CheckboxMenuBox = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'fixed',
        margin: '0px',
        padding: '8px',
        width: 'fit-content',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.borderColor,
        borderRadius: '5px',
        boxShadow: "0px 4px 16px ".concat(theme.boxShadow),
        zIndex: 1051,
    });
});
export var CheckboxMenuItemStyled = styled('div')(function (_a) {
    var theme = _a.theme, _b = _a.$disabled, $disabled = _b === void 0 ? false : _b;
    return ({
        cursor: 'pointer',
        height: '32px',
        padding: '0px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        opacity: $disabled ? 0.5 : 1,
        pointerEvents: $disabled ? 'none' : 'all',
    });
});
export var CheckboxMenuSpacerStyled = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        height: '2px',
        padding: '0px',
        margin: '8px 4px',
        backgroundColor: theme.colors.neutral.w300,
        pointerEvents: 'none',
    });
});
export var CheckboxMenuCheckboxWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '32px',
        height: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    });
});
export var CheckboxMenuLabelWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        minWidth: '32px',
        padding: '0px 8px',
    });
});
